export type RenderProgressBuffer = {
	unloadedStartTime: number | null
}

export function getModalityRenderEndTimes(
	responseBuffers: ReadonlyMap<string, RenderProgressBuffer>,
	modalities: string[],
	pageStartTime: number
): Record<string, number> {
	const endTimes: Record<string, number> = {}

	modalities.forEach(modality => {
		endTimes[modality] = responseBuffers.get(modality)?.unloadedStartTime ?? pageStartTime
	})

	return endTimes
}

export function areAllModalitiesRendered(
	endTimes: Record<string, number>,
	modalities: string[],
	pageEndTime: number
): boolean {
	return modalities.every(modality => Math.ceil(endTimes[modality] ?? 0) >= pageEndTime)
}

export function getEarliestRenderEndTime(
	endTimes: Record<string, number>,
	modalities: string[],
	pageStartTime: number
): number {
	return Math.min(...modalities.map(modality => endTimes[modality] ?? pageStartTime))
}
